/**
 * US local phone (NANP) — no country code. Normalizes paste variants to "(XXX) XXX-XXXX".
 */

function normalizeUsPhoneDigits(input) {
  let d = String(input ?? '').replace(/\D/g, '');
  if (d.length === 11 && d[0] === '1') d = d.slice(1);
  if (d.length > 10) d = d.slice(0, 10);
  return d;
}

/**
 * @param {string} [input]
 * @returns {string} Formatted phone or empty if no digits.
 */
export function formatUsLocalPhone(input) {
  const d = normalizeUsPhoneDigits(input);
  if (d.length === 0) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
